// extracted by mini-css-extract-plugin
export default {"not_found":"NotFound_not_found__ZbyST"};